




























































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import InfoRow from '@/views/AiiTasks/InfoRow.vue'
import feeRow from './feeRow.vue'
import { hasValue, debounce } from '@/utils/util'

const debounce300 = debounce(300)

@Component({
	components: {
		InfoRow,
		feeRow,
	},
})
export default class dependentFeeItem extends Vue {
	private itemRequired = false
	private feeRequired = false

	@Prop()
	private name!: any

	@Prop()
	private config!: any

	@Prop()
	private spans!: any

	@Prop()
	private index!: number

	@Prop()
	private form!: any

	@Prop()
	private unique!: number

	@Prop()
	private len!: number

	@Prop()
	private isReadonly!: number

	@Prop({ default: () => ({}) })
	private initial!: any

	private get readonlyRow() {
		let injured = (this.initial && this.initial.familyInfo) || {}
		return [
			{
				label: '姓名',
				value: injured.name,
			},
			{
				label: '与伤者关系',
				value: injured.relation,
			},
			{
				label: '年龄',
				value: injured.age,
			},
			{
				label: '赔付年限',
				value: injured.duration,
			},
		]
	}

	private setItemRequired() {
		let res =
			hasValue(this.form.getFieldValue(`${this.name}.familyInfo.name`)) ||
			hasValue(this.form.getFieldValue(`${this.name}.familyInfo.relation`)) ||
			hasValue(this.form.getFieldValue(`${this.name}.familyInfo.age`)) ||
			hasValue(this.form.getFieldValue(`${this.name}.familyInfo.duration`))
		this.itemRequired = !!res
	}

	private onChange() {
		debounce300(() => {
			this.setItemRequired()
		})
	}

	private feeChange(res: boolean) {
		this.feeRequired = res
	}

	private add() {
		this.$emit('addDependent')
	}

	private remove(unique: number) {
		this.$emit('removeDependent', unique)
	}

	private commercialChange() {
		this.$emit('commercialChange')
	}

	private compulsoryChange() {
		this.$emit('compulsoryChange')
	}

	private created() {
		this.setItemRequired()
	}
}
